import React from "react";
import {Button} from "reactstrap";

export function RefreshStats(props) {
    return <Button onClick={props.handleRefresh}>
        {props.isLoading ? "loading..." : "Refresh stats"}
    </Button>
}
